import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WorkingHoursModalComponent } from './working-hours-modal.component';
import { SharedModule } from 'lib-trend-core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule
  ],
  declarations: [
    WorkingHoursModalComponent
  ],
  exports: [
    WorkingHoursModalComponent
  ]
})
export class WorkingHoursModalModule { }
